'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseFeedFormat = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _utils = require('../utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function swapAndPair(values) {
  var out = [];

  for (var i = 0; i < values.length; i += 2) {
    var lat = values[i];
    var lon = values[i + 1];
    out.push([lon, lat]);
  }
  return out;
}

function parseGeometryValues(value) {
  var values = value.trim().split(/\s+/).map(parseFloat);
  return swapAndPair(values);
}

function parseGmlLine(node) {
  return swapAndPair((0, _utils.getText)(node, node.namespaceURI, 'posList').trim().split(/\s+/).map(parseFloat));
}

function parseGmlPolygon(node, namespaceURI) {
  var exteriorElement = (0, _utils.getFirstElement)(node, namespaceURI, 'exterior');
  var interiorElements = (0, _utils.getElements)(node, namespaceURI, 'interior');

  var exterior = parseGmlLine((0, _utils.getFirstElement)(exteriorElement, namespaceURI, 'LinearRing'), namespaceURI);

  var interiors = interiorElements.map(function (interiorElement) {
    return parseGmlLine((0, _utils.getFirstElement)(interiorElement, namespaceURI, 'LinearRing'), namespaceURI);
  });
  return [exterior].concat(_toConsumableArray(interiors));
}

function parseGmlEnvelope(node, namespaceURI) {
  var lowerLeftCorner = (0, _utils.getText)(node, namespaceURI, 'lowerCorner').trim().split(/\s+/).map(parseFloat);
  var upperRightCorner = (0, _utils.getText)(node, namespaceURI, 'upperCorner').trim().split(/\s+/).map(parseFloat);

  var bbox = [[[lowerLeftCorner[1], lowerLeftCorner[0]], [upperRightCorner[1], lowerLeftCorner[0]], [upperRightCorner[1], upperRightCorner[0]], [lowerLeftCorner[1], upperRightCorner[0]], [lowerLeftCorner[1], lowerLeftCorner[0]]]];
  return bbox;
}

function parseGml(node) {
  switch (node.localName) {
    case 'Point':
      {
        var coordinates = (0, _utils.getText)(node, node.namespaceURI, 'pos').trim().split(/\s+/).map(parseFloat);
        return {
          type: 'Point',
          coordinates: [coordinates[1], coordinates[0]]
        };
      }
    case 'LineString':
      {
        var _coordinates = parseGmlLine(node, node.namespaceURI);
        return {
          type: 'LineString',
          coordinates: _coordinates
        };
      }
    case 'Polygon':
      {
        var _coordinates2 = parseGmlPolygon(node, node.namespaceURI);
        return {
          type: 'Polygon',
          coordinates: _coordinates2
        };
      }
    case 'Envelope':
      {
        var _coordinates3 = parseGmlEnvelope(node, node.namespaceURI);
        return {
          type: 'Polygon',
          coordinates: _coordinates3
        };
      }
    case 'MultiPolygon':
      {
        var polygons = (0, _utils.getElements)(node, node.namespaceURI, 'polygonMember').map(function (surfaceMember) {
          return (0, _utils.getFirstElement)(surfaceMember, surfaceMember.namespaceURI, 'Polygon');
        });
        var _coordinates4 = polygons.map(function (polygon) {
          return parseGmlPolygon(polygon, node.namespaceURI);
        });
        return {
          type: 'MultiPolygon',
          coordinates: _coordinates4
        };
      }
    case 'MultiSurface':
      {
        // support both single 'surfaceMembers' or multiple 'surfaceMember' elements
        var _polygons = (0, _utils.getElements)(node, node.namespaceURI, 'surfaceMember').map(function (surfaceMember) {
          return (0, _utils.getFirstElement)(surfaceMember, surfaceMember.namespaceURI, 'Polygon');
        });
        var surfaceMembers = (0, _utils.getFirstElement)(node, node.namespaceURI, 'surfaceMembers');
        if (surfaceMembers) {
          _polygons = _polygons.concat((0, _utils.getElements)(surfaceMembers, surfaceMembers.namespaceURI, 'Polygon'));
        }
        var _coordinates5 = _polygons.map(function (polygon) {
          return parseGmlPolygon(polygon, node.namespaceURI);
        });
        return {
          type: 'MultiPolygon',
          coordinates: _coordinates5
        };
      }
    case 'geometryMember':
      {
        // go one level deeper to the first referenced geometry
        return parseGml((0, _utils.getFirstElement)(node));
      }
    default:
      break;
  }
  return null;
}

function boxFromLineString(lineString) {
  var minX = null;
  var minY = null;
  var maxX = null;
  var maxY = null;

  for (var i = 0; i < lineString.length; ++i) {
    var _lineString$i = _slicedToArray(lineString[i], 2),
        x = _lineString$i[0],
        y = _lineString$i[1];

    minX = minX === null || x < minX ? x : minX;
    minY = minY === null || y < minY ? y : minY;
    maxX = maxX === null || x > maxX ? x : maxX;
    maxY = maxY === null || y > maxY ? y : maxY;
  }
  return [minX, minY, maxX, maxY];
}

var BaseFeedFormat = exports.BaseFeedFormat = function () {
  function BaseFeedFormat() {
    _classCallCheck(this, BaseFeedFormat);
  }

  _createClass(BaseFeedFormat, [{
    key: 'parseGeometry',
    value: function parseGeometry(node) {
      var where = (0, _utils.getFirstElement)(node, 'georss', 'where');
      var point = (0, _utils.getText)(node, 'georss', 'point');
      var line = (0, _utils.getText)(node, 'georss', 'line');
      var polygon = (0, _utils.getText)(node, 'georss', 'polygon');

      if (where) {
        var geomNode = (0, _utils.getFirstElement)(where);
        if (geomNode) {
          return parseGml(geomNode);
        }
      } else if (point) {
        return {
          type: 'Point',
          coordinates: parseGeometryValues(point)[0]
        };
      } else if (line) {
        return {
          type: 'LineString',
          coordinates: parseGeometryValues(line)
        };
      } else if (polygon) {
        return {
          type: 'Polygon',
          coordinates: [parseGeometryValues(polygon)]
        };
      }
      return null;
    }
  }, {
    key: 'parseBox',
    value: function parseBox(node) {
      var box = (0, _utils.getText)(node, 'georss', 'box');
      if (box) {
        var values = box.split(/\s+/).map(parseFloat);
        return [values[1], values[0], values[3], values[2]];
      }
      return null;
    }
  }, {
    key: 'getBoxFromGeometry',
    value: function getBoxFromGeometry(geometry) {
      var coords = geometry.coordinates;
      switch (geometry.type) {
        case 'Point':
          return [coords[0], coords[1], coords[0], coords[1]];
        case 'LineString':
          return boxFromLineString(coords);
        case 'Polygon':
          return boxFromLineString(coords[0]);
        case 'MultiPolygon':
          {
            var bboxes = coords.map(function (polygon) {
              return boxFromLineString(polygon[0]);
            });
            var outBox = bboxes[0];
            for (var i = 1; i < bboxes.length; ++i) {
              var box = bboxes[i];
              outBox[0] = Math.min(outBox[0], box[0]);
              outBox[1] = Math.min(outBox[1], box[1]);
              outBox[2] = Math.max(outBox[2], box[2]);
              outBox[3] = Math.max(outBox[3], box[3]);
            }
            return outBox;
          }
        default:
          return null;
      }
    }
  }, {
    key: 'parseDate',
    value: function parseDate(node) {
      var date = (0, _utils.getText)(node, 'dc', 'date');
      if (date) {
        var values = date.split('/');
        if (values.length === 1) {
          return new Date(date);
        } else if (values.length >= 1) {
          return [new Date(values[0]), new Date(values[1])];
        }
      }
      return null;
    }
  }, {
    key: 'parseLinks',
    value: function parseLinks(node) {
      return (0, _utils.getElements)(node, 'atom', 'link').map(function (linkNode) {
        var link = {
          href: linkNode.getAttribute('href')
        };
        var rel = linkNode.getAttribute('rel');
        var type = linkNode.getAttribute('type');
        var title = linkNode.getAttribute('title');
        if (rel) {
          link.rel = rel;
        }
        if (type) {
          link.type = type;
        }
        if (title) {
          link.title = title;
        }

        return link;
      });
    }
  }, {
    key: 'parseMedia',
    value: function parseMedia(node) {
      var directMedias = (0, _utils.getElements)(node, 'media', 'content');
      var groups = (0, _utils.getElements)(node, 'media', 'group');
      var groupedMedias = groups.map(function (group) {
        return (0, _utils.getElements)(group, 'media', 'content');
      }).reduce(function (oldElems, newElems) {
        return oldElems.concat(newElems);
      }, []);
      var allMedias = directMedias.concat(groupedMedias);

      return allMedias.map(function (mediaNode) {
        var category = (0, _utils.getFirstElement)(mediaNode, 'media', 'category');
        return {
          url: mediaNode.getAttribute('url'),
          category: category ? category.textContent : undefined,
          scheme: category ? category.getAttribute('scheme') : undefined
        };
      });
    }
  }, {
    key: 'parseEOP',
    value: function parseEOP(node) {
      var eoNode = (0, _utils.getFirstElement)(node, null, 'EarthObservation');
      if (eoNode) {
        var eoEquipment = (0, _utils.simplePath)(eoNode, 'om:procedure/EarthObservationEquipment', true);
        return {
          productType: (0, _utils.simplePath)(eoNode, 'metaDataProperty/EarthObservationMetaData/productType/text()', true),
          processingLevel: (0, _utils.simplePath)(eoNode, 'metaDataProperty/EarthObservationMetaData/processing/ProcessingInformation/processingLevel/text()', true),
          platformShortName: (0, _utils.simplePath)(eoEquipment, 'platform/Platform/shortName/text()', true),
          platformSerialIdentifier: (0, _utils.simplePath)(eoEquipment, 'platform/Platform/serialIdentifier/text()', true),
          instrumentShortName: (0, _utils.simplePath)(eoEquipment, 'instrument/Instrument/shortName/text()', true),
          sensorType: (0, _utils.simplePath)(eoEquipment, 'sensor/Sensor/sensorType/text()', true),
          resolution: (0, _utils.simplePath)(eoEquipment, 'sensor/Sensor/resolution/text()', true) + (0, _utils.simplePath)(eoEquipment, 'sensor/Sensor/resolution@uom', true),
          orbitNumber: (0, _utils.simplePath)(eoEquipment, 'acquisitionParameters/Acquisition/orbitNumber/text()', true),
          cloudCoverPercentage: (0, _utils.simplePath)(eoNode, 'om:result/opt:EarthObservationResult/opt:cloudCoverPercentage/text()', true)
        };
      }
      return null;
    }
  }, {
    key: 'parseS3Path',
    value: function parseS3Path(node) {
      return (0, _utils.getText)(node, null, 's3Path');
    }
  }, {
    key: 'parseExtraFields',
    value: function parseExtraFields(node, extraFields, namespaces, item) {
      for (var outPath in extraFields) {
        if (Object.prototype.hasOwnProperty.call(extraFields, outPath)) {
          var maybePath = extraFields[outPath];
          var xmlPath = void 0;
          var single = true;
          if (Array.isArray(maybePath)) {
            var _maybePath = _slicedToArray(maybePath, 2);

            xmlPath = _maybePath[0];
            single = _maybePath[1];
          } else {
            xmlPath = maybePath;
          }

          var parts = outPath.split('.');
          var ref = item;
          for (var i = 0; i < parts.length - 1; ++i) {
            var part = parts[i];
            if (!ref[part]) {
              ref[part] = {};
            }
            ref = ref[part];
          }
          ref[parts[parts.length - 1]] = (0, _utils.simplePath)(node, xmlPath, single, namespaces);
        }
      }
    }
  }]);

  return BaseFeedFormat;
}();


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/formats/base.js